import styled from 'styled-components';

export const FormSectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.c2d3748};
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
`;

export const StepHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  padding-bottom: 16px;
`;

export const HeaderContent = styled.div`
  /* Container para o conteúdo do header */
`;

export const StepTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 700;
  color: ${(props: any) => props.theme.colors.c2d3748};
  margin: 0 0 8px 0;
`;

export const StepSubtitle = styled.p`
  font-size: 1rem;
  color: ${(props: any) => props.theme.colors.c718096};
  margin: 0;
`;